var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCaptionsOff(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.82989 2.00055H17.9999C19.0999 2.00055 19.9999 2.90055 19.9999 4.00055V16.0005C19.9999 16.0505 19.9899 16.1005 19.9799 16.1605L16.5999 12.7805C16.8399 12.5905 16.9999 12.3205 16.9999 12.0005V11.0005H15.4999V11.5005H15.3299L13.4999 9.67055V8.50055H15.4999V9.00055H16.9999V8.00055C16.9999 7.45055 16.5499 7.00055 15.9999 7.00055H12.9999C12.4499 7.00055 11.9999 7.45055 11.9999 8.00055V8.17055L5.82989 2.00055ZM18.7799 20.6105L16.1699 18.0005H3.99989C2.88989 18.0005 1.99989 17.1005 1.99989 16.0005V4.00055C1.99989 3.95055 2.01989 3.90055 2.01989 3.85055L0.389893 2.22055L1.79989 0.810547L20.1799 19.1905L18.7799 20.6105ZM9.99989 11.8305L9.16989 11.0005H8.49989V11.5005H6.49989V8.50055H6.66989L5.39989 7.22055C5.15989 7.41055 4.99989 7.68055 4.99989 8.00055V12.0005C4.99989 12.5505 5.44989 13.0005 5.99989 13.0005H8.99989C9.54989 13.0005 9.99989 12.5505 9.99989 12.0005V11.8305Z",
    fill: "#7F8090"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaptionsOff);
export default __webpack_public_path__ + "static/media/captions-off.1a38def5.svg";
export { ForwardRef as ReactComponent };